import type { QueryClient } from '@tanstack/react-query'
import type { MemberSessionResponse } from '@/components/member-portal/MemberSignIn'

export const memberSessionKey = ['member-portal-session'] as const

export function clearMemberLearning(queryClient: QueryClient) {
  // Removal cancels pending queries too: a late prior-member response must stay detached.
  queryClient.removeQueries({ queryKey: ['member-portal-my-learning'] })
}

export function replaceMemberSession(
  queryClient: QueryClient,
  session: MemberSessionResponse | null,
) {
  clearMemberLearning(queryClient)
  queryClient.removeQueries({ queryKey: ['member-portal-dashboard'] })
  queryClient.setQueryData(memberSessionKey, session)
}
